export interface ProductGroup {
  id: string;
  key: string;
  name: string;
}

export interface Tax {
  id: string;
  key: string;
  name: string;
}

export interface Product {
  id: string;
  key: string;
  ean: string;
  tax?: Tax;
  description1?: string;
  description2?: string;
  description3?: string;
  description4?: string;
  description5?: string;
  mainGroup?: ProductGroup;
  subGroup?: ProductGroup;
  subSubGroup?: ProductGroup;
}

export interface Unit {
  key: string;
  name: string;
}

export type LabelType = 'regaletikett' | 'fahnchen' | 'artikeletikett';

export const LABEL_TYPES: LabelType[] = ['regaletikett', 'fahnchen', 'artikeletikett'];

export const LABEL_TYPE_TITLE_KEY: Record<LabelType, string> = {
  regaletikett: '#UPDATED_ARTICLE_LABEL_PRINT.TABS.REGALETIKETT',
  fahnchen: '#UPDATED_ARTICLE_LABEL_PRINT.TABS.FAHNCHEN',
  artikeletikett: '#UPDATED_ARTICLE_LABEL_PRINT.TABS.ARTIKELETIKETT',
};

export interface ArticleLabelType {
  key: LabelType;
}

export type ChangeKey =
  | 'PRICE'
  | 'DESCRIPTION'
  | 'SUPPLIER'
  | 'EAN'
  | 'UNIT'
  | 'ARTICLE_NUMBER'
  | 'LISTED_STATUS'
  | 'PROMOTION';

export interface Change {
  key: ChangeKey;
  previousValue: string;
  currentValue: string;
  updatedAt: string;
}

export interface ShelfLabelDefinition {
  id: string;
  product: Product;
  changes: Change[];
  unit?: Unit;
  labelType: ArticleLabelType;
  selected: boolean;
}
